'use strict';

module.exports = {
	name: 'minecraft25',
	properties: {
		maxPlayers: 25
	}
};
